<div class="relative flex overflow-hidden rounded bg-white shadow">
  <input
    [(ngModel)]="input"
    (ngModelChange)="inputChange.emit(input)"
    (change)="inputChange.emit(input)"
    class="ml-10 w-full border-none p-0 focus:outline-none"
    [placeholder]="placeholder" />
  <img class="absolute left-4 top-[50%] -translate-y-1/2" src="assets/icon/search.svg" alt="search-icon" />
</div>
